export default {
  business_no: 'Business No',
  business_name: 'Business Name',
  business_type: 'Business Type',
  select_business_type: 'Select Business Type',
  self_operated: 'Self-operated',
  franchise: 'Franchise',
  business_region: 'Transaction Region',
  business_currency: 'Transaction Currency',
  related_franchisee: 'Related Franchisee',
  select_region: 'Select Region',
  select_currency: 'Select Currency',
  select_franchisee: 'Select Franchisee',
  description: 'Description',
  enter_description: 'Enter description',
  create_time: 'Create Time',
  create_business: 'Create Business',
  edit_business: 'Edit Business',
  business_detail: 'Business Detail',
  create_success: 'Created successfully',
  edit_success: 'Updated successfully',
  enter_business_name: 'Enter business name',
  franchisee_no: 'Franchisee No',
  franchisee_name: 'Franchisee Name',
  region: 'Region',
  currency: 'Currency',
  remark: 'Remark',
  enter_remark: 'Enter remark',
  contact_name: 'Contact Name',
  enter_contact_name: 'Enter contact name',
  contact_phone: 'Contact Phone',
  enter_phone: 'Enter phone number',
  contact_email: 'Contact Email',
  enter_email: 'Enter email address',
  create_franchisee: 'Create Franchisee',
  edit_franchisee: 'Edit Franchisee',
  franchisee_detail: 'Franchisee Detail',
  confirm_submit: 'Confirm Submission',
  confirm_franchisee: 'Please confirm the following franchisee information',
  submit: 'Submit',
  franchisee_create_success: 'Franchisee created successfully',
  franchisee_edit_success: 'Franchisee updated successfully',
  enter_franchisee_name: 'Enter franchisee name',
  select_business: 'Select Business',
  copy_success: 'Copied successfully',
  business_no_export: 'Business No',
  business_name_export: 'Business Name',
  franchisee_no_export: 'Franchisee No',
  franchisee_name_export: 'Franchisee Name',
  business: 'Business',
  franchisee: 'Franchisee'
}
